import { gql } from '@apollo/client';

export const fetchOrganisations = gql`
  query fetchOrgDetailsForPPC(
    $filterOptions: [FilterOption]
    $transactionAccountId: String
    $searchOptions: SearchOptions
  ) {
    fetchOrganisations(
      filterOptions: $filterOptions
      transactionAccountId: $transactionAccountId
      searchOptions: $searchOptions
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        organisationId
        organisationName
      }
    }
  }
`;
